import { Box, Toolbar } from "@mui/material";
import { ReactElement } from "react";
import Logo, { LogoProps } from "src/components/Logo";
import Page from "src/components/Page";
import { RootStyle } from "src/layouts/dashboard/login/rootStyle";
import HomePageImage from 'src/assets/copertina2.jpg'


type IProps = {
    pageTitle: string
    children: ReactElement
}

export default function AuthLayout(props: IProps) {
    const { pageTitle, children } = props;

    return (
        <Page title={pageTitle}>
            <RootStyle isCollapse={false} verticalLayout={true} isOffset={true}>
                <Toolbar sx={{ minHeight: '100% !important' }}>
                    <Box sx={{ width: 0.8, display: 'flex', ml: 11, alignItems: 'center', height: 1 }}>
                        <Logo color={LogoProps.MAIN} disabledLink={false} />
                    </Box>
                </Toolbar>
                <Box sx={{ display: 'flex', flexDirection: 'row', minHeight: '100vh' }}>
                    <Box
                        component="img"
                        src={HomePageImage}
                        alt=""
                        sx={{
                            width: '20%',
                            alignSelf: 'stretch',
                            objectFit: 'cover',
                            flexShrink: 0,
                        }}
                    />
                    {children}
                </Box>
            </RootStyle>
        </Page>
    )
}